module.exports = __webpack_public_path__ + "media/images/views/candidate/request/clip-82c6ff59b7f0b25edac6b966e61ae852.png";